export default __webpack_public_path__ + "static/media/ms-icon.73f03aea.svg";